import Sample from './Sample';

const { useState } = require('react');
const { default: Well } = require('./Well');

const Map = ({
  sampleActions,
  colorMapActions,
  selectedSampleActions,
  errorActions,
  batchSize
}) => {
  // maps wells to samples
  const [swapRange, setSwapRange] = useState({
    start: 96,
    end: -1,
  });

  const move = (toWell, sample) => {
    sampleActions.moveSample(toWell, sample);
    setSwapRange({
      start: 96,
      end: -1,
    });
  };

  const renderWells = () => {
    const columns = [[<div style={{height: '65px', width: '65px',}}></div>]];
    for (let row = 0; row < 8; row++) {
      columns[0].push(<div style={{height: '65px', width: '65px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>{String.fromCharCode(row + 'A'.charCodeAt(0))}</div>)
    }
    for (let column = 0; column < 12; column++) {
      const rows = [<div style={{height: '65px', width: '65px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>{column + 1}</div>];
      for (let row = 0; row < 8; row++) {
        const wellIndex = column * 8 + row;
        const sample = sampleActions.getSampleByWell(wellIndex);
        rows.push(
          <Well
            key={row}
            index={wellIndex}
            moveSample={move}
            selectedSamples={selectedSampleActions.getSelectedSamples()}
            swapRange={swapRange}
            setSwapRange={setSwapRange}
            errorActions={errorActions}
          >
            {sample ? (
              <Sample
                sample={sample}
                sampleActions={sampleActions}
                selectedSampleActions={selectedSampleActions}
                colorMapActions={colorMapActions}
              />
            ) : (
              ''
            )}
          </Well>
        );
      }
      columns.push(rows);
    }
    return columns;
  };

  return (
    <>
      {
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          {renderWells().map((row, index) => (
            <div
              key={index}
              style={{ display: 'flex', flexDirection: 'column' }}
            >
              {row}
            </div>
          ))}
        </div>
      }
    </>
  );
};

export const ItemTypes = {
  WELL: 'well',
  PRIMER: 'primer',
};

export default Map;
